import { useQuery } from '@tanstack/react-query';
import { destinationsApi, destinationsKeys } from '@/features/destinations/api/destinations.api';

export function useDestinations(params?: { page?: number; limit?: number; country?: string; search?: string }) {
  return useQuery({
    queryKey: [...destinationsKeys.list(), params],
    queryFn: () => destinationsApi.list(params),
  });
}
